import { orderPromotionTypes } from '@jarvis.oddle/core/tools/promotion'

export const analyseStoreOrder = (storeOrder: Oms.V4.StoreOrder): Record<string, any> => {
  // deliveryFreeAfter: 0 means there will be always deliveryFee (It actually means Infinity)
  const deliveryFreeAfter =
    storeOrder.deliveryFreeAfter === 0 ? Infinity : storeOrder.deliveryFreeAfter
  const hasDeliveryFee = !storeOrder.isPickup
  const reachedMinOrder = storeOrder.subtotal >= storeOrder.minimumOrder
  const reachedFreeDelivery =
    !hasDeliveryFee || storeOrder.remainingAmountToFreeDelivery === 0

  const deliveryPromotions = (storeOrder.orderPromotions || []).filter(
    (promotion) => promotion.type === orderPromotionTypes.deliveryOverride
  )
  const otherPromotions = (storeOrder.orderPromotions || []).filter(
    (promotion) => promotion.type === orderPromotionTypes.price
  )
  const minimumOrderOverridePromotions = (
    storeOrder.orderPromotions || []
  ).filter(
    (promotion) => promotion.type === orderPromotionTypes.minimumOrderOverride
  )
  const beforeDeliveryCharges = (storeOrder.taxAndCharges || []).filter(
    (charge) => !charge.isAppliedBeforeDelivery
  )
  const otherCharges = (storeOrder.taxAndCharges || []).filter(
    (charge) => charge.isAppliedBeforeDelivery
  )

  return {
    hasPromotions:
      storeOrder.orderPromotions && storeOrder.orderPromotions.length > 0,
    reachedMinOrder,
    amountToMinOrder: reachedMinOrder
      ? 0
      : storeOrder.minimumOrder - storeOrder.subtotal,
    hasDeliveryFee,
    hasFreeDelivery: deliveryFreeAfter !== Infinity,
    reachedFreeDelivery,
    amountToFreeDelivery: storeOrder.remainingAmountToFreeDelivery,
    hasMinimumOrder: !!storeOrder.minimumOrder,
    deliveryPromotions,
    otherPromotions,
    minimumOrderOverridePromotions,
    beforeDeliveryCharges,
    otherCharges,
    deliveryCost: storeOrder.deliveryCost,
    paymentAmount: (storeOrder.storeOrderPaymentDetails || {}).paymentAmount,
    surchargeDeliveryCost: storeOrder.surchargeDeliveryCost,
    locationDeliveryCost: storeOrder.locationDeliveryCost,
  }
}
